import type { ParsedSegment } from './types';

const LF = '\n'; // Line Feed
const CR = '\r'; // Carriage Return
const CRLF = '\r\n'; // Carriage Return + Line Feed

const isMacLineBreak = (char: string) => char === LF;

const isOldMacLineBreak = (char: string) => char === CR;

const isWindowsLineBreak = (char: string) => char === CRLF;

export const isLineBreak = (char: string) =>
  isWindowsLineBreak(char) || isOldMacLineBreak(char) || isMacLineBreak(char);

/**
 * Normalize segments to separate lines.
 * This is needed in order to render characters with line breaks when each
 * character is wrapped with an HTML element.
 *
 * @param segments - parsed segments
 * @returns parsed segments broken by lines
 */
export const normalizeSegmentsToLines = (
  segments: Array<ParsedSegment>,
): Array<Array<ParsedSegment>> => {
  const lines: Array<Array<ParsedSegment>> = [];
  let currentLine: Array<ParsedSegment> = [];

  for (const current of segments) {
    const data = current.data;

    if (isLineBreak(data)) {
      lines.push(currentLine);
      currentLine = [];
    } else {
      currentLine.push(current);
    }
  }

  lines.push(currentLine);

  return lines;
};
